import { Component, Input, OnInit, HostListener, OnDestroy, NgZone } from '@angular/core';
import { environment } from '~environment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

const NO_IMAGE_URL = `${environment.staticFiles}/images/property-noimage-default.png`;

@Component({
  selector: 'idap-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit {
  @Input() subnav: string;
  @Input() id: number;
  @Input() type: string = '.jpg';

  imageUrl: string;

  constructor(private zone: NgZone) { }

  ngOnInit() {
    this.imageUrl = `${environment.baseCdnUrl}/${this.subnav}/${this.id}${this.type}`;
  }

  onError(event) {
    this.zone.run(() => {
      this.imageUrl = NO_IMAGE_URL;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/images/image.component.ts